import axiosInstance from './../providers/Axios';
import {
  getBankBenefits,
  getCustomerExchanges,
  getBankCategories,
  getCustomerPoints,
  getProductsByCategory,
} from '../config/paths';

export const callGetBankBenefits = async () => {
  return axiosInstance({
    url: getBankBenefits,
    method: 'get',
  });
};

export const callGetCustomerExchanges = async (logonId) => {
  return axiosInstance({
    url: `${getCustomerExchanges}/${logonId}/exchanges`,
    method: 'get',
  });
};

export const callGetBankCategories = async () => {
  return axiosInstance({
    url: getBankCategories,
    method: 'get',
  });
};

export const callGetCustomerPoints = async (logonId) => {
  return axiosInstance({
    url: `${getCustomerPoints}/${logonId}/points`,
    method: 'get',
  });
};

export const callGetProductsByCategory = async (categoryId) => {
  return axiosInstance({
    url: `${getProductsByCategory}/${categoryId}/products`,
    method: 'get',
  });
};

export const callCreateCustomerExchange = async (logonId, newExchange) => {
  return axiosInstance({
    url: `${getCustomerExchanges}/${logonId}/exchanges`,
    method: 'post',
    data: newExchange,
  });
};
